import { ShimmerMetricRow } from "./DashboardShimmer";
import DashboardSummaryBox from "./DashboardSummaryBox";
import ProcessFlow from "./ProcessFlow";
import ProductionOutputDetails from "./ProductionOutputDetails";
import YieldEfficiency from "./YieldEfficiency";
import Operations from "./Operations";
import "./dashboard-sections.css";
import SlickSlider from "../../slider/SlickSlider";

const DUMMY = {
  total_paid_cases:  12450,
  total_paid_kg:     249000,
  total_orange_kg:   184200,
  total_ripened_kg:  58600,
  total_rejected_kg: 4120,
};

const SlickArrow = ({ direction, onClick }) => (
  <button
    type="button"
    className={`db-slick-arrow db-slick-${direction}`}
    onClick={onClick}
    aria-label={direction === "prev" ? "Previous" : "Next"}
  >
    {direction === "prev" ? (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
      </svg>
    ) : (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 18 15 12 9 6" />
      </svg>
    )}
  </button>
);

const BiggestDaily = ({ data = DUMMY, isLoading = false }) => {
  const metrics = [
    { label: "Total Paid Cases",  value: data.total_paid_cases?.toLocaleString(),  unit: "",   badge: "+4%" },
    { label: "Total Paid KG",     value: data.total_paid_kg?.toLocaleString(),     unit: "kg"  },
    { label: "Total Orange KG",   value: data.total_orange_kg?.toLocaleString(),   unit: "kg"  },
    { label: "Total Ripened KG",  value: data.total_ripened_kg?.toLocaleString(),  unit: "kg"  },
    { label: "Total Rejected KG", value: data.total_rejected_kg?.toLocaleString(), unit: "",   danger: true, dot: true },
    { label: "Total Rejected KG", value: data.total_rejected_kg?.toLocaleString(), unit: "",   danger: true, dot: true },
    { label: "Total Rejected KG", value: data.total_rejected_kg?.toLocaleString(), unit: "",   danger: true, dot: true },
  ];

  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    draggable: true,
    // prevArrow: <SlickArrow direction="prev" />,
    nextArrow: <SlickArrow direction="next" />,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 768,  settings: { slidesToShow: 2 } },
      { breakpoint: 480,  settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="db-section">
      {/* ── Slider ── */}
      {isLoading ? (
        <ShimmerMetricRow count={5} />
      ) : (
        <div className="db-slick-wrapper mb-3">
            <SlickSlider settings={slickSettings}>
                {metrics.map((item, i) => (
                <div key={`${item.label}-${i}`} className="db-slick-slide">
                    <DashboardSummaryBox data={item} />
                </div>
                ))}
            </SlickSlider>
        </div>
      )}

      {/* ── Process Flow + Production Output | Yield & Efficiency + Operations ── */}
      <div className="db-main-grid mt-3">
        {/* Left column */}
        <div className="db-main-left">
          <ProcessFlow isLoading={isLoading} />
          <ProductionOutputDetails isLoading={isLoading} />
        </div>
        {/* Right column */}
        <div className="db-main-right">
          <YieldEfficiency isLoading={isLoading} />
          <Operations isLoading={isLoading} />
        </div>
      </div>
    </div>
  );
};

export default BiggestDaily;
